import styled from "styled-components";

export enum AlertType {
    Danger = 'Danger',
    Warning = 'Warning',
    Success = 'Success',
    Notification = 'Notification',
    RecoverySuccess = 'RecoverySuccess',
}

interface AlertStyleProps  {
    type: AlertType
}

export const AlertContainer = styled.div<AlertStyleProps>`
  display: flex;
  transition: top 1s;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  width: fit-content;
  height: 48px;
  padding: 0 20px;
  color: #404040;
  background: ${({type}) => {
      switch (type) {
        case AlertType.Danger: return '#FFCCBE'
        case AlertType.Warning: return '#FAF798'
        case AlertType.Success: return '#FFFFFF'
        case AlertType.RecoverySuccess:
            return 'rgba(255, 255, 255, 1)'
        case AlertType.Notification: default: return '#FFFFFF'
      }
  }};
  position: fixed;
  box-shadow: 0 0 10px rgba(0,0,0,0.15);
  gap: 10px;
  top: -60px;
  left: 50vw;
  transform: translateX(-50%);
  border: 1px solid rgba(0, 0, 0, .1);
  border-radius: 5px;
  cursor: default;
  user-select: none;
`
export const RecoverySuccessAlertContainer = styled.div`
  display: flex;
  transition: top 1s;
  align-items: center;
  justify-content: center;
  z-index: 15;
  width: fit-content;
  height: 60px;
  padding: 0 20px;
  color: #404040;
  background: white;
  position: fixed;
  box-shadow: 0 0 10px rgba(0,0,0,0.15);
  gap: 10px;
  top: -60px;
  left: 50vw;
  transform: translateX(-50%);
  border: 1px solid rgba(0, 0, 0, .1);
  border-radius: 5px;
  cursor: default;
  user-select: none;
`
